import CompanyStore from './../../stores/Company'
export function companyHasModule(module) {
  if (CompanyStore.detail && CompanyStore.detail.modules)  {
    return CompanyStore.detail.modules.indexOf(module) > -1
  }

  return false
}
